<mat-accordion class="" multi>
  <mat-expansion-panel
    class="mat-elevation-z8 mt-3 mt-md-0"
    [expanded]="allPanelsOpen['basic']"
    (opened)="togglePanels('basic', true)"
    (closed)="togglePanels('basic', false)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5 class="mb-0">
          Basic Details
          <mat-icon
            class="edit-details"
            (click)="toggleEditMode('basic'); $event.stopPropagation()"
            *ngIf="!isEditingBasic && allPanelsOpen['basic']"
            >create</mat-icon
          >
        </h5>
        <div class="float-right">
          <button
            mat-flat-button
            color="primary"
            (click)="onSave('basic'); $event.stopPropagation()"
            *ngIf="isEditingBasic && allPanelsOpen['basic']"
          >
            Save
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="basicDetailsForm">
      <table mat-table class="feature-data" [dataSource]="basicDataSource" style="width: 100%">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>Value</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="isEditingBasic">
              <!-- Render homeType as a dropdown -->
              <ng-container *ngIf="element.key === 'propertySubType'">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <mat-select [formControlName]="element.key">
                    <mat-option *ngFor="let option of homeTypeOptions" [value]="option.value">
                      {{ option.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="element.key !== 'propertySubType'">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <span *ngIf="element.type != 'number'">
                    <input matInput [formControlName]="element.key" [mask]="fieldConfig[element.key]?.mask"
                  /></span>

                  <mat-error *ngIf="element.key === 'yearBuilt' && yearBuiltControl?.hasError('pattern')">
                    Year must be a valid number
                  </mat-error>
                  <mat-error *ngIf="element.key === 'yearBuilt' && yearBuiltControl?.hasError('min')">
                    Year cannot be less than 1800
                  </mat-error>
                  <mat-error *ngIf="element.key === 'yearBuilt' && yearBuiltControl?.hasError('max')">
                    Year cannot be greater than {{ currentYear }}
                  </mat-error>
                  <span *ngIf="element.type == 'number'">
                    <input
                      type="number"
                      [formControlName]="element.key"
                      [mask]="fieldConfig[element.key]?.mask"
                      matInput
                    />
                  </span>
                </mat-form-field>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!isEditingBasic">
              <span *ngIf="element.value"
                >{{ getViewValue(element.value, element.key) }}{{ fieldConfig[element.key]?.suffix }}</span
              >
              <span *ngIf="!element.value">--</span>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['name', 'value']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'value']"></tr>
      </table>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel
    class="mat-elevation-z8"
    [expanded]="allPanelsOpen['parking']"
    (opened)="togglePanels('parking', true)"
    (closed)="togglePanels('parking', false)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5 class="mb-0">
          Parking
          <mat-icon
            class="edit-details"
            (click)="toggleEditMode('parking'); $event.stopPropagation()"
            *ngIf="!isEditingParking && allPanelsOpen['parking']"
            >create</mat-icon
          >
        </h5>
        <div class="float-right">
          <button
            mat-flat-button
            color="primary"
            (click)="onSave('parking'); $event.stopPropagation()"
            *ngIf="isEditingParking && allPanelsOpen['parking']"
          >
            Save
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="parkingDetailsForm">
      <table mat-table class="feature-data" [dataSource]="parkingDataSource" style="width: 100%">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>Value</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="isEditingParking">
              <mat-form-field appearance="legacy" style="width: 100%">
                <input matInput [formControlName]="element.key" [mask]="fieldConfig[element.key]?.mask" />
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="!isEditingParking">
              <span *ngIf="element.value">{{ element.value }}{{ fieldConfig[element.key]?.suffix }}</span>
              <span *ngIf="!element.value">--</span>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['name', 'value']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'value']"></tr>
      </table>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel
    class="mat-elevation-z8"
    [expanded]="allPanelsOpen['basement']"
    (opened)="togglePanels('basement', true)"
    (closed)="togglePanels('basement', false)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5 class="mb-0">
          Basement
          <mat-icon
            class="edit-details"
            (click)="toggleEditMode('basement'); $event.stopPropagation()"
            *ngIf="!isEditingBasement && allPanelsOpen['basement']"
            >create</mat-icon
          >
        </h5>
        <div class="float-right">
          <button
            mat-flat-button
            color="primary"
            (click)="onSave('basement'); $event.stopPropagation()"
            *ngIf="isEditingBasement && allPanelsOpen['basement']"
          >
            Save
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="basementDetailsForm">
      <table mat-table class="feature-data" [dataSource]="BasementDataSource" style="width: 100%">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>Value</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="isEditingBasement">
              <mat-form-field appearance="legacy" style="width: 100%" *ngIf="element.type === 'dropdown'">
                <mat-select [formControlName]="element.key">
                  <mat-option *ngFor="let option of fieldConfig[element.key]" [value]="option.value">
                    {{ option.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <ng-container *ngIf="!element.type">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <input matInput [formControlName]="element.key" />
                </mat-form-field>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!isEditingBasement">
              <span>{{ getViewValue(element.value, element.key) }}</span>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['name', 'value']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'value']"></tr>
      </table>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel
    class="mat-elevation-z8"
    [expanded]="allPanelsOpen['interior']"
    (opened)="togglePanels('interior', true)"
    (closed)="togglePanels('interior', false)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5 class="mb-0">
          Interior
          <mat-icon
            class="edit-details"
            (click)="toggleEditMode('interior'); $event.stopPropagation()"
            *ngIf="!isEditingInterior && allPanelsOpen['interior']"
            >create</mat-icon
          >
        </h5>
        <div class="float-right">
          <button
            mat-flat-button
            color="primary"
            (click)="onSave('interior'); $event.stopPropagation()"
            *ngIf="isEditingInterior && allPanelsOpen['interior']"
          >
            Save
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="interiorRoomDetailsForm">
      <table mat-table class="feature-data" [dataSource]="interiorDataSource" style="width: 100%">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>Value</th>
          <td mat-cell *matCellDef="let element" class="pt-2">
            <ng-container *ngIf="isEditingInterior">
              <ng-container *ngIf="fieldConfig[element.key]?.type == 'multiselect'">
                <!-- <mat-chip-list #chipList *ngIf="isEditingInterior">
                  <mat-chip
                    *ngFor="let item of forms['interiorRoomDetailsForm']?.get(element.key)?.value"
                    (removed)="removeItem('interiorRoomDetailsForm', element.key, item)"
                    removable="true"
                  >
                    {{ item }}
                    <span matChipRemove [attr.aria-label]="'remove ' + item" style="opacity: 1 !important">
                      <mat-icon class="remove-icon">cancel</mat-icon>
                    </span>
                  </mat-chip>
                </mat-chip-list> -->

                <mat-chip-list *ngIf="interiorRoomDetailsForm.get(element.key)?.value as values">
                  <mat-chip
                    *ngFor="let value of values"
                    (removed)="removeItem('interiorRoomDetailsForm', element.key, value)"
                  >
                    {{ value }} <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </mat-chip-list>

                <mat-form-field appearance="legacy" class="appliances">
                  <input
                    matInput
                    placeholder="Type and press Enter to add"
                    (keyup.enter)="
                      addCustomOption('interiorRoomDetailsForm', element.key, inputField.value); inputField.value = ''
                    "
                    #inputField
                  />
                  <mat-select
                    [value]="interiorRoomDetailsForm.get(element.key)?.value"
                    (selectionChange)="
                      addSelectedOptions('interiorRoomDetailsForm', element.key, $event.value, inputField)
                    "
                    multiple
                  >
                    <mat-option *ngFor="let option of fieldConfig[element.key]?.options || []" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="!fieldConfig[element.key]?.type || fieldConfig[element.key]?.type === 'input'">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <input matInput [formControlName]="element.key" />
                </mat-form-field>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!isEditingInterior">
              <span *ngIf="element.value">{{ element.value }}{{ fieldConfig[element.key]?.suffix }}</span>
              <span *ngIf="!element.value">--</span>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['name', 'value']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'value']"></tr>
      </table>
    </form>
  </mat-expansion-panel>

  <div *ngFor="let room of rooms; let i = index">
    <mat-expansion-panel
      class="mat-elevation-z8"
      [expanded]="allPanelsOpen['room']"
      (opened)="togglePanels('room', true)"
      (closed)="togglePanels('room', false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title
          ><h5 class="mb-0">Room {{ i + 1 }}</h5></mat-panel-title
        >
      </mat-expansion-panel-header>
      <form [formGroup]="basementDetailsForm">
        <table mat-table class="feature-data" [dataSource]="[room]" style="width: 100%">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">Room Type</td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="isEditingBasement">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <input matInput [formControlName]="element.key" [mask]="fieldConfig[element.key]?.mask" />
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="!isEditingBasement">
                <span *ngIf="element.value">{{ element.value }}{{ fieldConfig[element.key]?.suffix }}</span>
                <span *ngIf="!element.value">--</span>
              </ng-container>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['name', 'value']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['name', 'value']"></tr>
        </table>
      </form>
    </mat-expansion-panel>
  </div>

  <mat-expansion-panel
    class=""
    [expanded]="allPanelsOpen['exterior']"
    (opened)="togglePanels('exterior', true)"
    (closed)="togglePanels('exterior', false)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5 class="mb-0">
          Exterior
          <mat-icon
            class="edit-details"
            (click)="toggleEditMode('exterior'); $event.stopPropagation()"
            *ngIf="!isEditingExterior && allPanelsOpen['exterior']"
            >create</mat-icon
          >
        </h5>
        <div class="float-right">
          <button
            mat-flat-button
            color="primary"
            (click)="onSave('exterior'); $event.stopPropagation()"
            *ngIf="isEditingExterior && allPanelsOpen['exterior']"
          >
            Save
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="exteriorDetailsForm">
      <table mat-table class="feature-data" [dataSource]="exteriorDataSource" style="width: 100%">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>Value</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="isEditingExterior">
              <ng-container *ngIf="!fieldConfig[element.key]?.type || fieldConfig[element.key]?.type === 'input'">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <input matInput [formControlName]="element.key" />
                </mat-form-field>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!isEditingExterior">
              <span *ngIf="element.value">{{ element.value }}{{ fieldConfig[element.key]?.suffix }}</span>
              <span *ngIf="!element.value">--</span>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['name', 'value']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'value']"></tr>
      </table>
    </form>
  </mat-expansion-panel>
</mat-accordion>
